"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOverlayFocus = void 0;
var react_1 = require("react");
function useOverlayFocus(visible, innerElementRef) {
    var outSideActiveElementRef = react_1.useRef(null);
    react_1.useEffect(function () {
        if (visible) {
            if (innerElementRef.current) {
                outSideActiveElementRef.current = document.activeElement;
                innerElementRef.current.focus({ preventScroll: true });
            }
        }
        else if (outSideActiveElementRef.current) {
            outSideActiveElementRef.current.focus({ preventScroll: true });
            outSideActiveElementRef.current = null;
        }
    }, [innerElementRef, visible]);
}
exports.useOverlayFocus = useOverlayFocus;
//# sourceMappingURL=use-overlay-focus.js.map